import React, { useEffect, useState } from "react";
import {
  IonAvatar,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonModal,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import "./CustomerReferrals.css";
import back_arrow from "../../../assets/images/common/arrow-left-white.png";
import { getCustomerReferrals } from "../../../data-services/edit-profile";
import EmptyScreen from "../../../push-components/EmptyScreen/EmptyScreen";
import {
  showToastMessage,
  somethingWentWrongErrMsg,
  unauthorizedErrorCode,
  offlineErrorCode,
} from "../../../common/common";
import { useDispatch } from "react-redux";
import { authActions } from "../../../store/auth";

type ModalProps = {
  is_open_cust_referral: boolean;
  closeCustReferral: Function;
  title: string;
};



const CustomerReferrals: React.FC<ModalProps> = (props) => {
  const dispatch = useDispatch();
  const {
    is_open_cust_referral,
    closeCustReferral,
    title,
  } = props;

  const [customerReferralsErrorMessage, setCustomerReferralsErrorMessage] = useState<any>("");
const [customerReferrals, setCustomerReferrals] = useState<any>([]);

  const referralInit = async () => {
    let api_res: any = await getCustomerReferrals();
    if (api_res?.success) {
      let referrals = [];
      for (let index = 0; index < api_res.data.referrals.length; index++) {
        let element = api_res.data.referrals[index];
        referrals.push({
          name: element.ucr_company_name,
          image: element.customer_image_url,
          status: element.status,
          point: element.points_earned,
          email: "",
        });
      }
      setCustomerReferrals(referrals);
    } else if (api_res?.data?.errorCode == unauthorizedErrorCode) {
      dispatch(authActions.logout());
      return;
    } else if (api_res?.data?.errorCode == offlineErrorCode) {
      setCustomerReferralsErrorMessage(api_res?.data?.message);
      showToastMessage(api_res?.data?.message);
    } else if (api_res?.message) {
      setCustomerReferralsErrorMessage(api_res.message);
      showToastMessage(api_res.message);
    } else {
      setCustomerReferralsErrorMessage(somethingWentWrongErrMsg);
      showToastMessage(somethingWentWrongErrMsg);
    }
  };

  

  useEffect(() => {
    (async () => {
      await referralInit();
    })();
  }, []);

  return (
    <IonModal isOpen={is_open_cust_referral} mode="ios">
      <IonHeader>
        <IonToolbar mode="ios" color="primary">
          <IonTitle>{title}</IonTitle>
          <IonButtons slot="start">
            <IonButton
              onClick={() => {
                closeCustReferral();
              }}
            >
              <img src={back_arrow} alt="" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="customer_referral">
          {customerReferrals.length > 0 &&
            customerReferrals.map((refe: any, index: number) => (
              <IonCard className="customer_referral__card" key={index}>
                <IonGrid className="customer_referral__grid">
                  <IonRow>
                    <IonCol size="2">
                      <IonAvatar className="customer_referral__img">
                        <img src={refe.image} alt="" />
                      </IonAvatar>
                    </IonCol>
                    <IonCol size="10">
                      <h2 className="customer_referral__titile">{refe.name}</h2>
                      {refe.email !== "" && (
                        <IonText className="customer_referral__email">
                          {refe.email}
                        </IonText>
                      )}

                      <div className="customer_referral__badges">
                        <IonBadge
                          className={
                            refe.status === "Pending"
                              ? "customer_referral__badge customer_referral__badge__blue"
                              : "customer_referral__badge customer_referral__badge__orange"
                          }
                        >
                          {refe.status}
                        </IonBadge>
                        {refe.point !== "" && (
                          <IonBadge className="customer_referral__badge">
                            Earned: {refe.point} Points
                          </IonBadge>
                        )}
                      </div>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonCard>
            ))}
          {customerReferrals.length == 0 && (
            <EmptyScreen
              title={customerReferralsErrorMessage ? customerReferralsErrorMessage : "No Referrals"}
            />
          )}
        </div>
      </IonContent>
    </IonModal>
  );
};

export default CustomerReferrals;
